import type { InputProps } from "@mui/material";
import { InputAdornment } from "@mui/material";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { AppInput } from "../../../../../shared/components/AppInput";
import { UserIcon } from "../../../../../shared/icons/UserIcon";
import styles from "../../styles.module.css";

interface Props extends InputProps {
  username: string;
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
}

export const LoginInput = ({ username, onChange, ...rest }: Props) => {
  const { t } = useTranslation();
  return (
    <AppInput
      value={username}
      onChange={onChange}
      name={"login"}
      type="text"
      startAdornment={
        <InputAdornment position="start">
          <UserIcon />
        </InputAdornment>
      }
      placeholder={t("login.username")}
      className={styles.input}
      inputClassName={styles["inner-input"]}
      {...rest}
    />
  );
};
